<bic-popup (close)="onCancel()" [hasBackdrop]="true" [title]='!data.isProject && organisation ? "Organisationsmitglieder hinzufügen" : data.isProject && project ? "Projektmitglieder hinzufügen" : null' customClass="w-[560px] h-[180px]">
  <div bicPopupContent class="flex flex-col">
    <div class="flex flex-col justify-center items-center w-full">
      <div class="flex flex-col w-[514px]">
        <div class="rounded-lg border border-gray-200 hover:border-gray-300 transition p-2 bg-gray-50">
          <input
            #userMail
            (keyup.enter)="addUserByMails()"
            class="w-full outline-none bg-gray-50 placeholder-gray-500 text-gray-800 text-[14px] px-1 py-[3px]"
            matInput
            placeholder="Einladen per E-Mail"
          >
        </div>
      </div>

    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button buttonType="white" (onClick)="onCancel()">Abbrechen</bic-button>
    <bic-button (onClick)="addUserByMails()">Hinzufügen</bic-button>
  </div>
</bic-popup>
